// IE-11 object.assign polyfill
if (typeof Object.assign !== 'function') {
  ;(function () {
    Object.assign = function (target) {
      'use strict'
      // We must check against these specific cases.
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert undefined or null to object')
      }

      const output = Object(target)
      for (let index = 1; index < arguments.length; index++) {
        const source = arguments[index]
        if (source !== undefined && source !== null) {
          for (const nextKey in source) {
            // eslint-disable-next-line no-prototype-builtins
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey]
            }
          }
        }
      }
      return output
    }
  })()
}

if (!String.prototype.includes) {
  const string = String
  string.prototype.includes = function (search, start) {
    'use strict'
    if (typeof start !== 'number') {
      start = 0
    }

    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}
